module.exports = __webpack_public_path__ + "img/edit.9e6c7e2f.svg";